"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2370],{

/***/ 62370:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "loadDestroyUpdater": function() { return /* binding */ loadDestroyUpdater; }
/* harmony export */ });
async function loadDestroyUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("destroy", async (container) => {
        const { DestroyUpdater } = await __webpack_require__.e(/* import() */ 6057).then(__webpack_require__.bind(__webpack_require__, 76057));
        return new DestroyUpdater(engine, container);
    }, refresh);
}


/***/ })

}]);